import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";
import { Button } from "./ui/button";
import { LogOut, UserCog } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";

export function DashboardHeader({ subtitle }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate("/login"); };

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 h-18 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link to="/" data-testid="header-logo-link" className="shrink-0 transition-opacity hover:opacity-70"><Logo className="h-9" /></Link>
          {subtitle && <span className="hidden sm:inline text-sm font-semibold text-[#64748B] border-l border-slate-200 pl-4">{subtitle}</span>}
        </div>
        <div className="flex items-center gap-4">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-bold text-[#373E45] leading-tight" data-testid="header-user-name">{user?.clinic_name}</p>
            <p className="text-xs text-[#64748B]">{user?.role === "admin" ? "Administrador" : "Clínica"}</p>
          </div>
          {user?.role === "clinic" && (
            <Link to="/cuenta" data-testid="account-link">
              <Button variant="outline" size="sm" className="rounded-xl border-slate-300 font-semibold text-[#373E45]">
                <UserCog className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">Mi cuenta</span>
              </Button>
            </Link>
          )}
          <Button variant="outline" size="sm" onClick={handleLogout} className="rounded-xl border-slate-300 font-semibold text-[#373E45]" data-testid="logout-btn">
            <LogOut className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">Salir</span>
          </Button>
        </div>
      </div>
    </header>
  );
}

export function StatusBadge({ status }) {
  const map = {
    pending: ["Pendiente", "bg-[#FBBC0C]/20 text-[#9a7400]"],
    confirmed: ["Confirmada", "bg-[#7FD498]/25 text-[#2f7a45]"],
    cancelled: ["Cancelada", "bg-slate-200 text-slate-500"],
  };
  const [label, cls] = map[status] || ["—", "bg-slate-100"];
  return <span className={`rounded-full px-3 py-1 text-xs font-bold ${cls}`} data-testid={`status-${status}`}>{label}</span>;
}
